var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-burger",class:("menu-burger--" + _vm.overlap)},[_c('div',{staticClass:"menu-burger__content",on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"menu-burger__line"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0984eac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Burger.vue
// module id = null
// module chunks = 